<template>
    <div>
        <table v-if="partners.length > 0" class="w-full mt-3">
            <thead class="bg-gray-100">
            <tr class="text-left border-b">
                <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">ID</th>
                <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">Name</th>
                <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">API Token</th>
                <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">Contacts</th>
                <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">Emails</th>
                <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500">Created At</th>
                <th class="p-2 text-xs uppercase font-semibold tracking-wider text-gray-500 whitespace-nowrap w-1">Actions</th>
            </tr>
            </thead>
            <tbody class="divide-y">
            <tr v-for="partner in partners">
                <td class="p-2">{{ partner.id }}</td>
                <td class="p-2">{{ partner.name }}</td>
                <td class="p-2">
                    <div class="flex w-full">
                        <input
                            class="border-gray-300 py-1 px-3 flex-grow text-sm font-mono"
                            type="text"
                            :value="partner.api_token"
                            readonly
                        >
                        <div class="border border-l-0 border-gray-300">
                            <copy-text :text="partner.api_token" mode="button" class="h-full px-2 hover:bg-gray-300"/>
                        </div>
                    </div>
                </td>
                <td class="p-2">{{ formatCount(partner.contacts) }}</td>
                <td class="p-2">{{ formatCount(partner.emails) }}</td>
                <td class="p-2">{{ partner.created_at }}</td>
                <td class="p-2 whitespace-nowrap w-1">
                    <a
                        :href="route('documentation.show', {partner: partner.id})"
                        target="_blank"
                        class="mr-1 rounded-md border border-transparent bg-pink-700 inline-flex items-center px-3 py-0.5 text-xs text-white uppercase tracking-widest font-semibold hover:bg-pink-600 transition"
                    >API Docs</a>

                    <inertia-link
                        v-if="partner.permissions.edit"
                        class="rounded-md border border-transparent bg-gray-800 inline-flex items-center px-3 py-0.5 text-xs text-white uppercase tracking-widest font-semibold hover:bg-gray-700 transition"
                        :href="partner.edit_url">Edit
                    </inertia-link>
                </td>
            </tr>
            </tbody>
        </table>
        <div v-else class="bg-gray-100 mt-3 rounded-md py-3 px-4">
            No partners have been created yet
        </div>
    </div>
</template>

<script>
import CopyText from '@/Components/CopyText.vue';

export default {
    components: { CopyText },

    props: ['partners'],

    setup() {
        return {
            formatCount(count) {
                return new Intl.NumberFormat().format(count);
            },
        };
    },
};
</script>

<style scoped>

</style>
